<template>
  <v-container fluid>
      <v-card>
          <v-toolbar dense color="#96298A" dark>
              <v-toolbar-title>Reporte de Reclamos</v-toolbar-title>
              <v-toolbar-items>
                  <v-divider class="mx-4" vertical />
                  <v-text-field full-width v-model="desde" type="date" clearable label="Desde"></v-text-field><v-divider class="mx-4" vertical />
                  <v-text-field full-width v-model="hasta" type="date" clearable label="Hasta"></v-text-field><v-divider class="mx-4" vertical />
                 <v-btn dark dense @click="getDatosReporte()" outlined exact > Generar <v-icon>mdi-file</v-icon></v-btn>
              </v-toolbar-items>
              <v-spacer></v-spacer>
              <v-toolbar-items>
                  <v-divider class="mx-4" vertical></v-divider>
                  <v-text-field
                    v-model="searcher"
                    append-icon="mdi-file-search"
                    label="Buscar"
                    single-line
                    hide-details
                    clearable
                    max-width="200px"
                    ></v-text-field>
                  <v-divider vertical></v-divider>
                    <v-tooltip bottom color="#96298A">
                        <template v-slot:activator="{ on, attrs }">
                        <v-btn icon large v-bind="attrs" v-on="on" @click="exportToExcel()">
                            <v-icon>mdi-microsoft-excel</v-icon>
                        </v-btn>
                        </template>
                        <span>Descargar Excel</span>
                    </v-tooltip>
              </v-toolbar-items>
          </v-toolbar>
          <v-card-text>
              <v-data-table
              :items="datosReporte"
              :headers="headersReporte"
              :search="searcher"
              >
              <template v-slot:item.direcciondestino="{ item }">
                  {{item.guia.direccion1_c + ' ' + item.guia.direccion2_c + ' ' + (item.guia.direccion3_c != null ? item.guia.direccion3_c : '')}}
              </template>
              <template v-slot:item.se_indemnizo="{ item }">
                  {{item.se_indemnizo == 1 ? 'Si': 'No'}}
              </template>
              </v-data-table>
          </v-card-text>
      </v-card>
  </v-container>
</template>

<script>
import apicon from '../plugins/apicon'
import utils from '../utils/utils'
const XLSX = require('xlsx')
export default {
created: function(){},
data(){
    return{
        desde: null,
        hasta: null,
        isCliente: false,
        searcher: '',
        datosReporte: [],
        headersReporte:[
            { text: "Fecha Admision Reclamo", value: "fecha_admision", sortable: false },
            { text: "Fecha Ocurrencia", value: "fecha_ocurrencia", sortable: false },
            { text: "Fecha Admisión Envío", value: "fecha_admision_envio", sortable: false },
            { text: "Identificación del Envío Postal", value: "guia.guia_interna", sortable: false },
            { text: "Contenido del Envío Postal", value: "guia.descripcion", sortable: false },
            { text: "Nombre del Remitente", value: "guia.empresa_e", sortable: false },
            { text: "Telefono de Contacto del Remitente", value: "guia.telefono_e", sortable: false },
            { text: "Correo Electronico para Notificaciones", value: "guia.correo_e", sortable: false },
            { text: "País de Origen", value: "guia.pais_e", sortable: false },
            { text: "Ciudad de Origen", value: "guia.ciudad_e", sortable: false },
            { text: "Nombre del Destinatario", value: "guia.empresa_c", sortable: false },
            { text: "Telefono de Contacto del Destinatario", value: "guia.telefono_c", sortable: false },
            { text: "País de Destino", value: "guia.pais_c", sortable: false },
            { text: "Ciudad de Destino", value: "guia.ciudad_c", sortable: false },
            { text: "Destino o Direccion Postal", value: "direcciondestino", sortable: false },
            { text: "Servicio Contratado", value: "guia.servicio", sortable: false },
            { text: "Causal del Reclamo", value: "causal.causal", sortable: false },
            { text: "Estado del Reclamo", value: "estado.estado", sortable: false },
            { text: "Fecha Finalización", value: "fecha_finalizacion", sortable: false },
            { text: "Se Indemnizo", value: "se_indemnizo", sortable: false },
            { text: "Valor Cancelado por Indemnización", value: "valor_indemnizacion", sortable: false },
            { text: "Acuerdo Pactado", value: "acuerdo_pactado", sortable: false },
            { text: "Reseña", value: "reseña", sortable: false },
            { text: "AWB Operador", value: "guia.guia_proveedor", sortable: false },
            { text: "Operador", value: "guia.proveedor", sortable: false },
        ],
    }
},
methods:{
    getDatosReporte: function(){
        apicon.saveDataApi(apicon.getApiBaseUrl() + 'reportereclamos',{
            desde: this.desde,
            hasta: this.hasta
            }).then((result) => {
                this.datosReporte = result
            });
    },
    formatDate: function(date){
        return utils.formatDate(date)
    },
    exportToExcel: function(){
        //Map Data to new Json
        let newJson = this.datosReporte.map(rec => {
            return{
                "Fecha Admision Reclamo": rec.fecha_admision != null ? new Date(rec.fecha_admision + 'T00:00:00') : '',
                "Fecha Ocurrencia": rec.fecha_ocurrencia != null ? new Date(rec.fecha_ocurrencia + 'T00:00:00') : '',
                "Fecha Admisión Envío": rec.fecha_admision_envio != null ? new Date(rec.fecha_admision_envio + 'T00:00:00') : '',
                "Identificación del Envío Postal": rec.guia.guia_interna,
                "Contenido del Envío Postal": rec.guia.descripcion,
                "Nombre del Remitente": rec.guia.empresa_e,
                "Telefono de Contacto del Remitente": rec.guia.telefono_e,
                "Correo Electronico para Notificaciones": rec.guia.correo_e,
                "País de Origen": rec.guia.pais_e,
                "Ciudad de Origen": rec.guia.ciudad_e,
                "Nombre del Destinatario": rec.guia.empresa_c,
                "Telefono de Contacto del Destinatario": rec.guia.telefono_c,
                "País de Destino": rec.guia.pais_c,
                "Ciudad de Destino": rec.guia.ciudad_c,
                "Destino o Direccion Postal": rec.guia.direccion1_c + ' ' + rec.guia.direccion2_c + ' ' + (rec.guia.direccion3_c != null ? rec.guia.direccion3_c : ''),
                "Servicio Contratado": rec.guia.servicio,
                "Causal del Reclamo": rec.causal ? rec.causal.causal : '',
                "Estado del Reclamo": rec.estado ? rec.estado.estado : '',
                "Fecha Finalización": rec.fecha_finalizacion != null ? new Date(rec.fecha_finalizacion + 'T00:00:00') : '',
                "Se Indemnizo": rec.se_indemnizo == 1 ? 'Si' : 'No',
                "Valor Cancelado por Indemnización": rec.valor_indemnizacion,
                "Acuerdo Pactado": rec.acuerdo_pactado,
                "Reseña": rec.reseña,
                "AWB Operador": rec.guia.guia_proveedor,
                "Operador": rec.guia.proveedor,
            }
        });
        let data = XLSX.utils.json_to_sheet(newJson)
        const workbook = XLSX.utils.book_new()
        const filename = 'Reporte de Reclamos';
        //Fit columns
        const wscols = utils.getAutoFitColumns(newJson);
        data["!cols"] = wscols;

        XLSX.utils.book_append_sheet(workbook, data, filename)
        XLSX.writeFile(workbook, `${filename}.xlsx`)
    },
},
mounted: function(){
    apicon.setAuthHeaders();
    this.isCliente = localStorage.getItem("cliente");
    //this.getDatosReporte();
}
}
</script>
